import React, { useState, useEffect } from 'react';
import { register, setDisplayName } from '../../../firebase/authService';
import { addStateToFirestore, getStatesFromFirestore } from '../../../firebase/stateService';
import { mapAuthError } from '../../../utils/authErrors';
import { validateEmailFormat, normalizeEmail } from '../../../utils/validation';
import { hasFirebaseConfig } from '../../../firebase/firebaseConfig';
import { useAuth } from '../../../firebase/AuthContext';
import { useNavigate } from 'react-router-dom';
import styles from './SignUp.module.css';

export default function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [displayName, setDisplayNameState] = useState('');
  const [error, setError] = useState(null);
  const [errorVisible, setErrorVisible] = useState(false);
  const ready = hasFirebaseConfig();
  const navigate = useNavigate();
  const { refreshUser } = useAuth() || {};

  useEffect(() => {
    if (error) {
      setErrorVisible(true);
      const t = setTimeout(() => setErrorVisible(false), 5000);
      return () => clearTimeout(t);
    } else {
      setErrorVisible(false);
    }
  }, [error]);

  const onSubmit = (e) => {
    e.preventDefault();
    setError(null);
    const normalized = normalizeEmail(email);
    if (!normalized || !password || !password2) {
      setError('すべて入力してください');
      return;
    }
    if (!validateEmailFormat(normalized)) {
      setError('メールアドレスの形式が不正です');
      return;
    }
    if (password !== password2) {
      setError('パスワードが一致しません');
      return;
    }
    (async () => {
      try {
        const user = await register(normalized, password);
        if (displayName) {
          try {
            await setDisplayName(displayName);
            if (refreshUser) refreshUser();
          } catch(e) {
            console.warn('displayName 設定失敗', e);
          }
        }
        // デフォルト状態を登録
        const defaultStates = [
          '完成',
          '未組立',
          '塗装済み未組立',
          '塗装中',
          '仮組',
          '仮組途中',
          '未開封',
        ];
        if (user && user.uid) {
          const existingStates = await getStatesFromFirestore(user.uid);
          const existingNames = existingStates.map(s => s.name);
          for (const name of defaultStates) {
            if (!existingNames.includes(name)) {
              await addStateToFirestore(name, user.uid, 'post');
            }
          }
        }
        // 登録成功後はホームへ
        navigate('/');
      } catch (err) {
        console.error(err);
  setError(mapAuthError(err));
      }
    })();
  };

  if (!ready) {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>アカウント作成</h1>
        <div style={{ textAlign:'center', lineHeight:1.6 }}>
          Firebase 設定が読み込まれていないため登録は利用できません。<br />
          runtime-firebase-config.js を配置するか configureFirebase() を実行してください。
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>アカウント作成</h1>
      <form className={styles.form} onSubmit={onSubmit} noValidate>
        <label className={styles.label}>
          表示名 (任意)
          <input
            type="text"
            className={styles.input}
            value={displayName}
            onChange={(e) => setDisplayNameState(e.target.value)}
            placeholder="Your Name"
          />
        </label>
        <label className={styles.label}>
          メールアドレス
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </label>
        <label className={styles.label}>
          パスワード
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
        </label>
        <label className={styles.label}>
          パスワード(確認)
          <input
            type="password"
            className={styles.input}
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            placeholder="••••••••"
            required
          />
        </label>
  {error && errorVisible && <div className={styles.error}>{error}</div>}
        <button type="submit" className={styles.submit}>登録する</button>
        <div className={styles.links}>
          <a href="/signin">サインインへ戻る</a>
        </div>
      </form>
    </div>
  );
}
